import {useMemo} from 'react';

import {type PanelType} from '../../util/panelTypes';

/**
 * Returns the CSS class name for a panel's viewType.
 *
 * NOTE: Some multi-word panel types have malformed classNames due to a legacy bug
 * where only the first space was replaced. These are maintained for backward compatibility.
 *
 * Example:
 * - "Run History Line Plot" → "run-history line plot-container"
 * - "Multi Run Table" → "multi-run table-container"
 * - "Parallel Coordinates Plot" → "parallel-coordinates plot-container"
 *
 * @param panelType - The panel's viewType string
 * @returns The CSS class name if the panel type is recognized, undefined otherwise
 */
export const usePanelViewTypeClass = (
  panelType: PanelType
): string | undefined => {
  return useMemo(() => {
    // Once we're confident that we've migrated all of the panels to a better format, then we can remove this. "plot-container" gets used in many places including tests
    return panelType.toLowerCase().replace(' ', '-') + '-container';
  }, [panelType]);
};
